import { UserActivation } from '@fiverr-private/code_activation';

export default UserActivation;
